import { render, staticRenderFns } from "./relationsNetworkMenu.vue?vue&type=template&id=182b6d2c&scoped=true&"
import script from "./relationsNetworkMenu.vue?vue&type=script&lang=js&"
export * from "./relationsNetworkMenu.vue?vue&type=script&lang=js&"
import style0 from "./relationsNetworkMenu.vue?vue&type=style&index=0&id=182b6d2c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "182b6d2c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/corp-dev.1clicom.ru/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('182b6d2c')) {
      api.createRecord('182b6d2c', component.options)
    } else {
      api.reload('182b6d2c', component.options)
    }
    module.hot.accept("./relationsNetworkMenu.vue?vue&type=template&id=182b6d2c&scoped=true&", function () {
      api.rerender('182b6d2c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/ui/relationsNetwork/relationsNetworkMenu.vue"
export default component.exports